import themeColors from '@/assets/theme/colors'

const classes = {
  // Positioned, so the photo layer and the scrim above it both resolve
  // against the hero rather than against the page.
  subsection: {
    position: 'relative' as 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 2
  },
  subsectionDiv: {
    zIndex: 10
  },
  linkDiv: {
    marginTop: '4rem',
    display: 'flex'
  },
  linkButton: {
    minWidth: 150,
    padding: '0.7rem 1.5rem',
    fontWeight: 600,
    letterSpacing: '0.03em',
    boxShadow: 'none',
    background: themeColors.success.darker,
    zIndex: 2,
    '&:hover': {
      background: themeColors.success.main,
      boxShadow: 'none'
    }
  },
  // Secondary action: readable on the photo without competing with the first.
  linkButtonGhost: {
    minWidth: 150,
    padding: '0.7rem 1.5rem',
    fontWeight: 600,
    letterSpacing: '0.03em',
    color: '#fff',
    borderColor: 'rgba(255,255,255,0.7)',
    zIndex: 2,
    '&:hover': {
      borderColor: '#fff',
      background: 'rgba(255,255,255,0.12)'
    }
  }
}

export default classes
